<template>
  <div>LAYOUT SEMINAIRE</div>
</template>

<script>
export default {};
</script>

<style>
</style>
